export const RECORDS_LIMIT = 10;
export const NURBS_API_URL = 'https://nurbs.uvislands.com';
export const AWS_REGION = 'eu-west-2';
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const LOCAL_STORAGE_KEYS = {
    TOKEN: 'token',
    AWS: 'aws'
}
